import React, { FunctionComponent } from 'react';
import { useStravaAuth } from '../../hooks';
import { StravaButton } from '../StravaButton/StravaButton';
import { useTranslation } from 'react-i18next';

export interface StravaFitnessSectionProps {
  isConnected: boolean;
  isPaused: boolean;
  className?: string;
  onManageSettingsClick: () => void;
}

export const StravaFitnessSection: FunctionComponent<StravaFitnessSectionProps> = ({
  isConnected,
  isPaused,
  className,
  onManageSettingsClick,
}) => {
  const stravaAuthCallback = useStravaAuth();
  const { t } = useTranslation();

  const getDescription = () => {
    if (isPaused) {
      return t('fitnessSection.strava.description.paused');
    }

    if (isConnected) {
      return t('fitnessSection.strava.description.connected');
    }

    return t('fitnessSection.strava.description.notConnected');
  };

  return (
    <div className={className}>
      <p className="jg-text--large">{getDescription()}</p>
      <StravaButton
        onStravaAuth={stravaAuthCallback}
        onModalOpen={onManageSettingsClick}
        isConnected={isConnected}
      />
    </div>
  );
};
